import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
// import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import DataTable from '../../../components/table/Table';
import SearchBox from '../../../components/table/SearchBox';
import { CommonConfig } from '../../../config/common-config';
// import { getIMCclientDetails } from '../../users/store/actions/index';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

function IMCView(props) {
    const history = useHistory();
    const location = useLocation();
    // const [rows, setTotalReactPackages] = useState([]);
    const dispatch = useDispatch({});
    // const imcclients = useSelector((state) => state.users.imcClients);

    const [imcclients, SetImcclients] = useState([]);

    const createimc = useSelector((state) => state.createimc.createimc);
    let rows = [];
    imcclients && imcclients.content && imcclients.content.length && imcclients.content.map((datadbname, i) => {
        if (datadbname.dbName !== 'itec') {
            rows.push(datadbname);
        }
    });
    const [searchQuery, setSearchQuery] = useState('');
    const [deletedata, setDeleteData] = useState(rows);
    //console.log("location.deletedata", location.deletedata);
    const [deleteMsg, setDeleteMsg] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const classes = useStyles();
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };

    const headCells = [
        { id: 'intClientName', label: 'Name of the entity' },
        { id: 'gstIn', label: 'GSTIN' },
        {
            id: 'addressId',
            label: 'Address',
            isConcat: 'true',
            concatElem: ['addressLine1', 'addressLine2', 'city', 'stateId.stateName', 'country'],
        },
        { id: 'dbName', label: 'Domain Name' },
        { id: 'adminMobile', label: 'Admin Mobile Number' },
        { id: 'adminEmail', label: 'Admin Mail ID' },
    ];

    const handleClose = () => {
        setShowLoader(false);
        setSuccessPop(false);
        setErrorPop(false);
    };

    const { breadCrumbLabel, breadCrumbPath } = props;
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState();
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const myRef = useRef();

    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }
        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    useEffect(
        (data) => {
            // history.push({
            //     state: { breadCrumbLabel, breadCrumbPath },
            // });
            // dispatch(getIMCclientDetails({ params: bearerToken }));
            if (searchQuery && searchQuery.length > 2) {
                getSearchValueAdmin(searchQuery);
            } else {
                getIMC();
            }
        },
        [deletedata, createimc, userToken]
    );

    const getIMC = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients?page=${page}&size=10&sort=intClientName,asc`, axiosConfig)
            .then((response) => {
                SetImcclients(response.data);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    }

    const getSearchValueAdmin = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients?search=${data}&page=${page}&size=10&sort=intClientName,asc`, axiosConfig)
            .then((res) => {
                console.log('responseresponse11', res);
                if (res.data) {
                    if (res.data.content.length === 0) {
                        SetImcclients([]);
                    }
                    // formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getIMC();
    }

    const handleSearchQuery = (data) => {
        // setSearchQuery(searchData);
        setSearchQuery(data);
        // console.log('data', data);
        if (data && data.length > 2) {
            setNoRecordCount(false);
            getSearchValueAdmin(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getIMC();
        }
    };

    const handleDelete = (data) => {
        setShowLoader(true);
        if (data.tenantClientId) {
            axios
                .delete(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients/${data.tenantClientId}`, axiosConfig)
                .then((response) => {
                    const { status } = response;
                    if (status === 204) {
                        const list = rows.filter((m) => m.tenantClientId !== data.tenantClientId);
                        setDeleteData({ rows: list });
                        setShowLoader(true);
                        setTimeout(() => {
                            setShowLoader(false);
                            setSuccessPop(true);
                        }, 1500);
                        setTimeout(() => {
                            setSuccessPop(false);
                        }, 3000);

                    }
                })
                .catch((e) => {
                    //console.log(e);
                    const errResult = e.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        }
    };

    const navigate = () => {
        history.push('/menu/imc');
    };

    // const filteredRow = searchQuery
    //     ? rows &&
    //     rows.filter((row) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
    //         //   ////console.log(headCells.map(col => col.id));
    //         return headCells
    //             .map((col) => col.id)
    //             .some((key) => {
    //                 //console.log(row[key],"Value of ROW****row[key]");
    //                 return row[key].toString().toLowerCase().includes(query);
    //             });
    //     })
    //     : rows;

    // filtered based on nested objects

    // Filtered Row based on search for nested objects
    const filteredRow = searchData && searchData.length ? searchData : rows;
    // const filteredRow = searchQuery
    //     ? rows.filter((searchRow) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headCells
    //             .map((col) => col)
    //             .some((key) => {
    //                 //console.log(key, 'from inside some');
    //                 if (key.isConcat && searchRow[key.id]) {
    //                     const subdata = searchRow[key.id];
    //                     const mergedData = key.concatElem.map((concatdata) => {
    //                         //console.log(concatdata,"concatData");
    //                         return concatdata.split('.').reduce((acc, item) => {
    //                             //   ////console.log(acc ,item,"Acc item from reduce");
    //                             if (Object.prototype.hasOwnProperty.call(acc, item)) {
    //                                 //  ////console.log(acc[item],"values from acc");

    //                                 if (typeof acc[item] !== 'object') {
    //                                     return acc[item].toString().toLowerCase().includes(query);
    //                                 }
    //                                 return acc[item];
    //                             }

    //                             return false;
    //                         }, subdata);
    //                     });
    //                     //console.log(mergedData,"mergeData");

    //                     return mergedData[0];
    //                 }
    //                 return searchRow[key.id].toString().toLowerCase().includes(query);
    //             });
    //     })
    //     : rows;

    const back = () => {
        props.history.push('/menu');
    };

    return (
        <>
            {showLoader ? (<LoaderPopUp showLoader={showLoader} />) : null}
            {successpop ? (<SuccessPopUp open={successpop} showSuccess={successpop} title="IMC deleted successfully" />) : null}
            {errorpop ? (<ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} />) : null}

            <Card className="custom-table mb10">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={6}>
                        <Typography className="card-title">Intermediary Clients</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                        </div>
                        <div className="card-add-button">
                            <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                                Add Intermediary Client
                            </Button>
                        </div>
                    </Grid>

                    {/* <FormDialog row={[]} pageName="imc" show="AddIcon" /> */}
                </CardContent>
                <CardContent className="card-table-display">
                    {rows && filteredRow.length > 0 ? (
                        <>
                            <DataTable
                                rows={filteredRow}
                                headCells={headCells} pageName="imc"
                                handleDelete={handleDelete}
                                action
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }} />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                </CardContent>
            </Card>
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
                </Button>
        </>
    );
}
export default IMCView;
